import { ApiClient } from '@/libs/ApiClient';
import Cookies from 'js-cookie';

export default {
  async install(Vue: any) {
    const jwt = Cookies.get('__ms.jwt');
    if (jwt) {
      const api = new ApiClient(jwt);
      Vue.prototype.$api = api;
    } else {
      Vue.prototype.$api = new ApiClient();
    }
  },
};
